<div class="w-full h-full p-1">
    <app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">
        <p-scrollPanel [style]="{ width: '100%', height: '100%' }">
            @if (pericalOptionsForm) {
            <form [formGroup]="pericalOptionsForm" class="flex flex-col space-y-2 p-2">

                <div class="flex flex-col">
                    <label for="maximumGridSpacing">Vertical Grid Spacing</label>
                    <app-validated-number-input
                        [id]="'maximumGridSpacing'"
                        [control]="control('maximumGridSpacing')"
                        [value]="control('maximumGridSpacing').value"
                        [validation]="gridSpacingValidation"
                        [unit]="verticalGridUnit">
                    </app-validated-number-input>
                </div>

                @if (!hideGridRefinement) {
                    <div>
                        <p-checkbox inputId="disableRefinement" size="small" binary="true" formControlName="disableInterfaceRefinement"></p-checkbox>
                        <label class="ml-1" for="disableRefinement">Disable Interface Refinement (Altus only)</label>
                    </div>
                }

                <label class="underline">Energy & Enthalpy Effects</label>

                <p class="text-sm">Adjustment factors are built into the thermal numerical solution scheme to promote convergence and
                    maintain stability. Alternative values to the internal defaults may be specified here and selectively
                    applied to individual operations:
                </p>

                <div class="flex flex-col">
                    <label for="successiveRelationFactor">Successive Relaxation Factor (Energy Terms)
                        <i pTooltip=" The default of value of 0.3 is tuned to provide stability but not slow down convergence."
                            class="pi pi-info-circle cursor-help"></i>
                    </label>
                    <app-validated-number-input
                        [id]="'successiveRelationFactor'"
                        [control]="control('successiveRelationFactor')"
                        [value]="control('successiveRelationFactor').value"
                        [validation]="successiveRelationFactorValidation">
                    </app-validated-number-input>
                </div>

                <div class="flex flex-col">
                    <label for="latentHeatDampingFactor">Latent Heat Damping Factor (Stability)
                        <i pTooltip=" The default value of 100 is set to limit numerical instability.  However, it may be reduced to increase the impact of Latent Heat of Phase Change."
                            class="pi pi-info-circle cursor-help"></i>
                    </label>
                    <app-validated-number-input
                        [id]="'latentHeatDampingFactor'"
                        [control]="control('latentHeatDampingFactor')"
                        [value]="control('latentHeatDampingFactor').value"
                        [validation]="latentHeatDampingFactorValidation">
                    </app-validated-number-input>
                </div>

                <div class="space-x-1">
                    <p-checkbox inputId="includeLatentHeatPhaseChange" size="small" binary="true" formControlName="includeLatentHeatPhaseChange">
                    </p-checkbox>
                    <label for="includeLatentHeatPhaseChange">
                        Include Latent Heat of Phase Change
                        <i pTooltip="If Latent Heat of Phase Change is included, it may be necessary to reduce the Relaxation Factor, e.g. 0.1."
                            class="pi pi-info-circle cursor-help">
                        </i>
                    </label>
                </div>

            </form>
            }
        </p-scrollPanel>
    </app-tool-loader>
</div>